import React from 'react';
import { Stack } from 'rsuite';

const Copyright = () => {
  return (
    <Stack className="copyright" justifyContent="center" style={{ height: 40, marginTop: 20 }}>
      <div className="container">
        <p>
          © 2025 
          <a href="https://elites.com" target="_blank" rel="noreferrer">
          ELITES
          </a>
        </p>
      </div>
    </Stack>
  );
};

export default Copyright;
